import styled from 'styled-components';

export const ChipGroup = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  margin: var(--spacing-sm) 0;
`;

export const Chip = styled.div<{ isSelected?: boolean }>`
  padding: 4px 10px;
  border-radius: 12px;
  cursor: pointer;
  font-family: var(--font-primary);
  font-size: var(--text-xs);
  font-weight: var(--font-weight-medium);
  color: ${props =>
    props.isSelected ? 'var(--foreground)' : 'var(--text-muted)'};
  background: ${props =>
    props.isSelected ? 'var(--surface-elevated)' : 'transparent'};
  transition: all 150ms ease-out;

  &:hover {
    color: var(--foreground);
    background: ${props =>
      props.isSelected ? 'var(--surface-elevated)' : 'var(--gray-700)'};
  }
`;
